enum AuthException {
  AuthException = 'AuthException',
  AuthInvalidPasswordException = 'AuthInvalidPasswordException',
  AuthUsernameExistsException = 'AuthUsernameExistsException',
  AuthUserNotFoundException = 'AuthUserNotFoundException',
  AuthLoginFailedException = 'AuthLoginFailedException',
  AuthTokenNotFoundException = 'AuthTokenNotFoundException',
}

export const AuthExceptionMessage = {
  [AuthException.AuthException]:
    'There was an error during login. Please try again.',
  [AuthException.AuthInvalidPasswordException]:
    'The password restrictions are not met.',
  [AuthException.AuthUsernameExistsException]: 'The user already exists.',
  [AuthException.AuthUserNotFoundException]: 'The email or password is wrong.',
  [AuthException.AuthLoginFailedException]: 'The email or password is wrong.',
  [AuthException.AuthTokenNotFoundException]:
    'The reset password token is invalid.',
};

export default AuthException;
